var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeltaAirlineLogoDl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 64.67",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m33.83 38.15-8.57-4.13v-9.08zm.68 1.58-9.25-3.91v3.91z",
    fill: "#801a2a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.68 38.15 8.57-13.21v9.08zm-.68 1.58h9.25v-3.91z",
    fill: "#cb2f34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m35.26 37.02c.34 0 .61.27.61.6s-.27.61-.6.61-.61-.27-.61-.6.27-.61.6-.61zm0 1.12c.29 0 .52-.23.52-.51 0-.29-.23-.52-.51-.52-.29 0-.52.23-.52.51 0 .29.23.52.52.52zm-.14-.16h-.09v-.7h.27c.16 0 .22.07.22.19 0 .11-.08.19-.17.2l.21.31h-.1l-.21-.31h-.12v.31zm0-.4h.12c.1 0 .2 0 .2-.12 0-.09-.09-.12-.15-.12h-.15v.24z",
    fill: "#801a2a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m41.74 38.15h4.16c4.28 0 6.83-2.22 6.83-5.89s-2.54-5.89-6.83-5.89h-4.16zm2.63-9.73h1.53c2.77 0 4.17 1.37 4.17 3.84s-1.39 3.84-4.17 3.84h-1.53zm22.3 2.58h-5v-2.58h5.65v-2.04h-8.29v11.78h8.48v-2.04h-5.84v-3.06h5zm10.75-4.63h-2.64v11.78h7.72v-2.04h-5.08zm8.72 2.05h3.96v9.73h2.65v-9.73h3.96v-2.04h-10.57zm25.86 9.73h-2.76l-1.15-2.95h-4.79l-1.15 2.95h-2.57l4.92-11.83h2.66zm-4.66-4.92-1.64-4.19-1.65 4.19z",
    fill: "#19346b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h128v64.67h-128z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 64.67h128v64.67h-128z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeltaAirlineLogoDl);
export default __webpack_public_path__ + "static/media/delta_airline_logo_DL.0327bda4cf6b32194b7a409308ede64b.svg";
export { ForwardRef as ReactComponent };